import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Form, Input, message, Upload, Icon, Button, Skeleton } from 'antd'
import { inject } from 'mobx-react'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'

const GET_SETTINGS = gql`
    query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
    }
`

const SET_BARANGAY_SIGNATURE_PHOTO = gql`
    mutation setBarangaySignaturePhoto(
        $input: JSON
    ) {
        setBarangaySignaturePhoto(
            input: $input
        )
    }
`

const DELETE_BARANGAY_LOGO = gql`
    mutation deleteSignaturePhoto(
        $input: JSON
    ) {
        deleteSignaturePhoto(
            input: $input
        )
    }
`

const BarangaySignatoryPhoto = (props) => {
	const { 
		AuthStore, form, saveBarangayLogo, deleteBarangayLogo, ...rest 
	} = props
	const { getFieldDecorator, resetFields } = form
	const { barangay_uid } = AuthStore
	const [isSaving, setSaving] = useState(false)
	const [hasSelectedLogo, setSelectedLogo] = useState(false)
    
	const handleSubmit = (e) => {
		e.preventDefault()
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const fileList = _.has(values.logo, 'fileList') ? values.logo.fileList : []
			const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
			const files = []
			if (formattedFiles.length > 0) {
				files.push(formattedFiles[formattedFiles.length - 1])
			}
			delete values.logo
			values = Object.assign({}, values, { files, barangay_uid, code: 'BRGY_SIGNATORY_SIGNATURE' })

			message.loading({ key: 'set_brgy_logo', content: 'Saving Barangay Logo, please wait..' })
			setSaving(true)
			saveBarangayLogo(values).then((response) => {
				setSaving(false)
				message.success({ key: 'set_brgy_logo', content: 'Barangay Logo successfully saved.' })
				window.location.reload()
			}).catch(err => {
				setSaving(false)
				console.log('error saving barangay logo')
				message.error({ key: 'set_brgy_logo', content: err.message.replace('GraphQL error:', '') })
				resetFields()
			})
		})
	}

	const handleDeleteLogo = (logo_uid) => {
		message.loading({ key: 'delete_brgy_logo', content: 'Deleting Barangay Logo, please wait..' })
		setSaving(true)
		deleteBarangayLogo({ logo_uid }).then((response) => {
			setSaving(false)
			message.success({ key: 'delete_brgy_logo', content: 'Barangay Logo successfully deleted.' })
			resetFields()
		}).catch(err => {
			setSaving(false)
			console.log('error deleting barangay logo')
			message.error({ key: 'delete_brgy_logo', content: err.message.replace('GraphQL error:', '') })
		})
	}

	const fileProps = Object.assign({}, rest, {
		name: 'file',
		multiple: false,
		onChange(info) {
			if (info.fileList.length > 0) {
				setSelectedLogo(true)
			} else {
				setSelectedLogo(false)
			}
			
			if (_.isEqual(info.file.status, 'removed')) {
				console.log('file removed', info.file)
				if (_.has(info.file, 'fromServer') && info.file.fromServer) {
					handleDeleteLogo(info.file.uid)
				}
			}
		},
		beforeUpload (file, fileList) { return false },
		showUploadList: true,
		accept: 'image/jpeg, image/png',
		listType: 'picture-card'
	})

	const uploadButton = (
		<div disabled={hasSelectedLogo}>
		  <Icon type={'plus'} />
		  <div className="ant-upload-text">Upload</div>
		</div>
	  )

	return (
		<Query query={GET_SETTINGS} variables={{ barangay_uid, code: 'BRGY_SIGNATORY_SIGNATURE' }}>
			{({ loading, error, data }) => {
				if (loading) return <Skeleton active/>

				const mSetting = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				let defaultFileList = []
				if (_.has(mSetting, 'value') && mSetting.value) {
					defaultFileList = [{
						uid: mSetting.uid,
						name: mSetting.value,
						status: 'done',
						url: `${process.env.REACT_APP_BACKEND_API}${mSetting.value}`,
						fromServer: true
					}]
				}
				return (
					<div style={{ position: 'relative' }}>
						<Form onSubmit={handleSubmit}>
							<Form.Item label='eSignature'>
								{ getFieldDecorator('logo', {
									//initialValue: (mSetting) ? mSetting.value : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Upload defaultFileList={defaultFileList} {...fileProps}>
										{
											(hasSelectedLogo || (_.has(mSetting, 'value') && mSetting.value)) ? null : uploadButton
										}
									</Upload>
								)}
							</Form.Item>
						</Form>
						{
							(_.has(mSetting, 'value') && mSetting.value) ? null :
								<button disabled={isSaving} onClick={handleSubmit} style={{ position: 'absolute', top: '49px', right: '1px' }} type="button" className="btn btn-primary waves-effect waves-light">Save</button>
						}
					</div>
				)
			}}
		</Query>
	)
}

const composed = compose(
	Form.create({ name: 'form-barangay-logo' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_SIGNATURE_PHOTO, {
		props({ mutate }) {
			return {
				saveBarangayLogo(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangaySettingsByCode']
					})
				}
			}
		}
	}),
	graphql(DELETE_BARANGAY_LOGO, {
		props({ mutate }) {
			return {
				deleteBarangayLogo(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangaySettingsByCode']
					})
				}
			}
		}
	})
)

export default composed(BarangaySignatoryPhoto)